

function decodeInt32(buf, offset = 0) {
	return (buf[offset] << 24) | (buf[offset+1] << 16) | (buf[offset+2] << 8) | buf[offset+3];
}

function encodeInt32(buf, offset, v) {
	//Big-Endian flags
	buf[offset] = (v >> 24) & 0xff;
	buf[offset + 1] = (v >> 16) & 0xff;
	buf[offset + 2] = (v >> 8) & 0xff;
	buf[offset + 3] = v & 0xff;
}

export const BigEndian = {
	encodeInt32,
	decodeInt32
};
